import { Navigate, Route, Routes, useLocation } from 'react-router';
import { useAuth } from '@/contexts/auth';
import { ForgotPasswordScene } from '@/features/auth/ForgotPasswordScene';
import { ResetPasswordScene } from '@/features/auth/ResetPasswordScene';
import { SignInScene } from '@/features/auth/SignInScene';
import { SignUpScene } from '@/features/auth/SignUpScene';
import { SmartDefaultRoute } from '@/features/plan/components/SmartDefaultRoute';
import { PlanScene } from '@/features/plan/scenes/PlanScene';

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { user, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return null;
  }

  if (!user) {
    return <Navigate to="/sign-in" state={{ from: location }} replace />;
  }

  return <>{children}</>;
}

export function AppRoutes() {
  return (
    <Routes>
      <Route
        path="/day/:targetDate?"
        element={
          <ProtectedRoute>
            <PlanScene />
          </ProtectedRoute>
        }
      />
      <Route
        path="/week/:targetDate?"
        element={
          <ProtectedRoute>
            <PlanScene />
          </ProtectedRoute>
        }
      />
      <Route
        path="/quarter/:targetDate?"
        element={
          <ProtectedRoute>
            <PlanScene />
          </ProtectedRoute>
        }
      />
      <Route
        path="/year/:targetDate?"
        element={
          <ProtectedRoute>
            <PlanScene />
          </ProtectedRoute>
        }
      />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <SmartDefaultRoute />
          </ProtectedRoute>
        }
      />
      <Route
        path="/:targetDate"
        element={
          <ProtectedRoute>
            <PlanScene />
          </ProtectedRoute>
        }
      />
      <Route path="/sign-in" element={<SignInScene />} />
      <Route path="/sign-up" element={<SignUpScene />} />
      <Route path="/forgot-password" element={<ForgotPasswordScene />} />
      <Route path="/reset-password" element={<ResetPasswordScene />} />
    </Routes>
  );
}
